const { REACT_APP_ENV } = process.env;

export const isProduction = () => REACT_APP_ENV === 'production';
